import React from "react";

/**
 * @typedef {Object} PageTab
 * @property {string} id
 * @property {string} label
 * @property {boolean} enabled
 * @property {boolean} [comingSoon]
 */

/**
 * @param {{
 * tabs: PageTab[],
 * currentTab: string,
 * onChange: (tabId: string) => void,
 * ariaLabel?: string
 * }} props
 */
const PageTabs = ({ tabs, currentTab, onChange, ariaLabel = "Page tabs" }) => {
  return (
    <div className="sco-page-tabs-shell">
      <div className="sco-page-tabs" role="tablist" aria-label={ariaLabel}>
        {tabs.map((tab) => {
          const isActive = currentTab === tab.id;
          const isDisabled = !tab.enabled;

          return (
            <button
              key={tab.id}
              type="button"
              className={`sco-page-tab${isActive ? " is-active" : ""}`}
              role="tab"
              aria-selected={isActive}
              aria-disabled={isDisabled}
              disabled={isDisabled}
              onClick={() => !isDisabled && onChange(tab.id)}
            >
              <span>{tab.label}</span>
              {tab.comingSoon ? (
                <span className="sco-page-tab-pill">Coming Soon</span>
              ) : null}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default PageTabs;
